/**
 * AgentStatusChip — colored badges for Agents Portal run statuses, finding
 * statuses, severities, kinds, and action-taken values. One component so the
 * color language stays consistent across the portal.
 */
import React from 'react';
import { Badge } from '@chakra-ui/react';

const STYLES = {
  // run statuses
  queued: { colorScheme: 'gray', label: 'queued' },
  running: { colorScheme: 'blue', label: 'running' },
  done: { colorScheme: 'green', label: 'done' },
  error: { colorScheme: 'red', label: 'error' },
  cancelled: { colorScheme: 'gray', label: 'cancelled' },
  // finding statuses
  new: { colorScheme: 'orange', label: 'new' },
  reviewed: { colorScheme: 'blue', label: 'reviewed' },
  confirmed: { colorScheme: 'red', label: 'confirmed' },
  false_positive: { colorScheme: 'gray', label: 'false positive' },
  // severities
  low: { colorScheme: 'gray', label: 'low' },
  medium: { colorScheme: 'yellow', label: 'medium' },
  high: { colorScheme: 'orange', label: 'high' },
  critical: { colorScheme: 'red', label: 'critical' },
  // kinds
  phishing: { colorScheme: 'red', label: 'phishing' },
  spam: { colorScheme: 'yellow', label: 'spam' },
  suspicious: { colorScheme: 'orange', label: 'suspicious' },
  // actions
  none: { colorScheme: 'gray', label: 'none' },
  labeled: { colorScheme: 'blue', label: 'labeled' },
  quarantined: { colorScheme: 'purple', label: 'quarantined' },
  trashed: { colorScheme: 'red', label: 'trashed' },
};

export default function AgentStatusChip({ value, ...rest }) {
  const s = STYLES[value] || { colorScheme: 'gray', label: value || '—' };
  return (
    <Badge colorScheme={s.colorScheme} variant="subtle" borderRadius="md" px={2} {...rest}>
      {s.label}
    </Badge>
  );
}
